
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyPilarWest as ObiBuoyPilarWestElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-pilar-west.js';
 
 
 

 
 export const ObiBuoyPilarWest = createComponent({
   react: React,
   tagName: 'obi-buoy-pilar-west',
   elementClass: ObiBuoyPilarWestElement,
   events: {
     
   }
  });
 
 